import { IconAlertCircle } from '@developerz/ui';
import { type JSX, Show } from 'solid-js';
import { t, tPlural } from '../i18n';
import { type RefusedOutcome, refusalCopy } from '../lib/task-refusal';

// The refused verdict (#1100). Presenter — the ONE branch of `<NewTaskResult/>`
// with a decision in it, so it owns a file and a test rather than growing the
// switch past its cap.
//
// Two channels, two lines: the framing copy (`refusalCopy` — sharpened by the
// 429's `retry_after` extension when the server sent one) and, under it, the
// API's own `detail` sentence with the numbers behind the refusal.

export type NewTaskRefusedProps = {
  readonly refused: RefusedOutcome;
};

export function NewTaskRefused(props: NewTaskRefusedProps): JSX.Element {
  const copy = (): ReturnType<typeof refusalCopy> => refusalCopy(props.refused);
  const title = (): string => {
    const c = copy();
    return c.count === undefined ? t(c.key, c.vars) : tPlural(c.key, c.count, c.vars);
  };

  return (
    <div class="alert alert--icon alert--destructive" role="alert">
      <IconAlertCircle />
      <p class="alert__title">{title()}</p>
      <Show when={props.refused.detail}>{(detail) => <p class="alert__desc">{detail()}</p>}</Show>
    </div>
  );
}
